import "./intruments";
import { RouterProvider } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

import "./App.css";

import Routes from "./routes/routes";
import * as Sentry from "@sentry/react";
import { getConfig } from "./config";

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "Nunito",
    },
  },
});

const queryClient = new QueryClient()

function App() {
  const AppContent = () => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={Routes} />
        </QueryClientProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );

  return (
    <div className="App">
      {console.log(getConfig().shouldEnableSentry)}
      {getConfig().shouldEnableSentry ? (
        <Sentry.ErrorBoundary>
          <AppContent />
        </Sentry.ErrorBoundary>
      ) : (
        <AppContent />
      )}
    </div>
  );
}

export default App;
